import { Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { useContactForm } from "../../hooks/useContactForm";

const inputClass = "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white placeholder:text-zinc-500 outline-none transition-colors focus:border-[#00E5FF] focus:ring-1 focus:ring-[#00E5FF]";
const fields = {
  name: { label: "Nombre", placeholder: "Tu nombre", maxLength: 120, autoComplete: "name" },
  business: { label: "Negocio", placeholder: "Nombre de tu negocio", maxLength: 160, autoComplete: "organization" },
  email: { label: "Email", placeholder: "tu@email.com", type: "email", autoComplete: "email" },
  message: { label: "Mensaje", placeholder: "Cuéntanos qué necesitas...", maxLength: 4000 },
};

const ContactField = ({ name, value, onChange }) => {
  const { label, ...attributes } = fields[name];
  const Element = name === "message" ? "textarea" : "input";
  return (
    <div>
      <label htmlFor={`contact-${name}`} className="mb-2 block text-sm text-zinc-400">{label}</label>
      <Element {...attributes} id={`contact-${name}`} name={name} data-testid={`contact-${name}`}
        aria-required={name !== "business"} rows={name === "message" ? 5 : undefined}
        className={`${inputClass}${name === "message" ? " resize-none" : ""}`} value={value} onChange={onChange} />
    </div>
  );
};

export const ContactForm = () => {
  const { form, loading, update, submit } = useContactForm();
  return (
    <form onSubmit={submit} noValidate data-testid="contact-form" aria-busy={loading}
      className="rounded-3xl border border-white/10 bg-[#101018] p-5 sm:p-8 md:p-10">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {["name", "business"].map((name) => <ContactField key={name} name={name} value={form[name]} onChange={update(name)} />)}
      </div>
      {["email", "message"].map((name) => (
        <div key={name} className="mt-5"><ContactField name={name} value={form[name]} onChange={update(name)} /></div>
      ))}
      <div className="hidden" aria-hidden="true">
        <label htmlFor="contact-website">Website</label>
        <input id="contact-website" name="website" data-testid="contact-website" tabIndex={-1} autoComplete="off" value={form.website} onChange={update("website")} />
      </div>
      <button type="submit" data-testid="contact-submit" disabled={loading} aria-label={loading ? "Enviando solicitud" : "Enviar solicitud"}
        className="group mt-7 flex w-full items-center justify-center gap-2 rounded-full bg-[#00E5FF] py-4 text-base font-semibold text-[#0A0A0C] transition-transform hover:-translate-y-0.5 disabled:opacity-60">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Enviar solicitud <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></>}
      </button>
      <p data-testid="contact-privacy-notice" className="mt-4 text-center text-xs text-zinc-500">
        Al enviar aceptas nuestra <Link to="/politica-de-privacidad" data-testid="contact-privacy-link" className="underline underline-offset-2 transition-colors hover:text-white">Política de Privacidad</Link>. No almacenamos tus datos: solo los recibimos por email para responderte.
      </p>
    </form>
  );
};